import { Component, ElementRef, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { fromEvent, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Tag } from 'src/app/_apps/cmdb/models';

@Component({
    selector: 'aa-autocomplete-option',
    templateUrl: './autocomplete-option.component.html',
    styleUrls: [
        './autocomplete-option.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AutocompleteOptionComponent implements OnInit
{
    @Input() value: Tag;
    click: Observable<Tag>;

    constructor (private host: ElementRef)
    {
    }

    ngOnInit ()
    {
        this.click = fromEvent(this.element, 'click')
            .pipe(
                map(() => this.value)
            );
    }

    get element ()
    {
        return this.host.nativeElement;
    }
}
